import { Row } from 'antd';
import styled from 'styled-components';

export const OpeningRow = styled(Row)`
    background: ${(props) => props.theme.colors.secondaryBackground};
    padding: 10px;
`;

export default OpeningRow;
